export const getRequestHoliday = ({ addError }) => async (id: string): Promise<any> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/request-holiday/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: any = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};



// WEBPACK FOOTER //
// ./src/modules/hr-requests/holidays/_requestsHolidayActions.ts